class VariantRadios extends HTMLElement {
    constructor() {
        super();
        this.flavorTitle = this.querySelector('.js-variant-radios-ttl');
        this.addEventListener('change', this.onVariantChange);
        this.onVariantClick();
        this.from = this.closest('form');
    }

    onVariantClick() {
        this.querySelectorAll('.js-variant-radios-label').forEach(el => {
            el.addEventListener('click', () => {
                if (this.querySelector(`#${el.getAttribute('for')}`).checked) {
                    this.classList.toggle('is-open');
                } else {
                    this.classList.remove('is-open');
                }
            });
        });
        document.querySelector('body').addEventListener('click', e => {
            if (e.target.closest('.variant-radios') == null) {
                this.classList.remove('is-open');
            }
        });
    }

    onVariantChange(e) {
        this.updateOptions();
        this.updateMasterId();
        this.updateMasterIdMetafileds();
        this.updateVariantStatuses();
        this.updateAddToCart();
        this.hideNotification();


        if (!this.currentVariant) {
        } else {
            this.updateVariantInput();
            this.updateFlavorTitle();
            this.updateURL();
        }
    }
    updateAddToCart(){
        const productForm = this.from;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
        if (!this.currentVariant) {
            addButton.classList.add('is-disabled');
        } else {
            if (this.currentVariant.available) {
                addButton.classList.remove('is-disabled');
            } else {
                addButton.classList.add('is-disabled');
            }
        }
    }

    hideNotification() {
        const productForm = this.from;
        if (!productForm) return;
        const notification = productForm.querySelector('.slidecart-form-error');
        if (notification!= null) {
            notification.remove();
        }
    }

    updateAddToCart() {
        const productForm = this.from;
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (!this.currentVariant) {
            addButtonText.textContent = theme.productStrings.unavailable;
            addButton.setAttribute('disabled', 'disabled');
        } else {
            if (this.currentVariant.available) {
                addButtonText.textContent = theme.productStrings.addToCart;
                addButton.removeAttribute('disabled');
            } else {
                if(this.currentVariantMetafields.coming_soon == "true"){
                    addButtonText.textContent = theme.productStrings.comingSoon;
                }else{
                    addButtonText.textContent = theme.productStrings.soldOut;
                }
                addButton.setAttribute('disabled', 'disabled');
            }
        }

    }

    updateFlavorTitle() {
        if (this.flavorTitle != null) {
            this.flavorTitle.textContent = this.currentVariant.options[parseInt(this.flavorTitle.getAttribute('data-index'), 10)];
        }
    }


    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMasterIdMetafileds() {
        if (this.currentVariant) {
            this.currentVariantMetafields = this.getVariantMetafieldsData().find((variant) => {
                return variant.id == this.currentVariant.id;
            });
        }
    }

    updateURL() {
        const body = document.querySelector('body');
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        if(!body.classList.contains("template-collection") && !body.classList.contains("template-search")) {
            window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
    }


    updateVariantInput() {
        const productForms = document.querySelectorAll(`form`);
        const body= document.querySelector('body');
        productForms.forEach((productForm) => {
            const select = productForm.querySelector('#productSelect');
            if (select != null) {
                select.value = this.currentVariant.id;
                if(!body.classList.contains("template-collection") && !body.classList.contains("template-search")) {
                    select.dispatchEvent(new Event('change', {bubbles: true}));
                }
            } else {
                const input = productForm.querySelector('[name="id"]');
                if (input != null) {
                    input.value = this.currentVariant.id;
                    if(!body.classList.contains("template-collection") && !body.classList.contains("template-search")) {
                        input.dispatchEvent(new Event('change', {bubbles: true}));
                    }
                }
            }
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);

        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
            const available2OptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability2(optionInputs, available2OptionInputsValue)
        });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"].js-variants').textContent);
        return this.variantData;
    }

    getVariantMetafieldsData() {
        this.variantMetafieldsData = this.variantMetafieldsData || JSON.parse(this.querySelector('[type="application/json"].js-variants-metafields').textContent);
        return this.variantMetafieldsData;
    }

    setInputAvailability2(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('is-unavailable');
            } else {
                input.classList.add('is-unavailable');
            }
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
            } else {
                input.classList.add('disabled');
            }
        });
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"]:not(.disabled):checked')];
            if (optionInputs.length == 0) {
                const optionInputsEnable = [...option.querySelectorAll('input[type="radio"]:not(.disabled)')];
                if (optionInputsEnable.length > 0) {
                    optionInputsEnable[0].checked = true;
                    optionInputsEnable[0].dispatchEvent(new Event('change', {bubbles: true}));

                }
            }
        });

    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);